import { SERVICE_TYPES } from '@bagonboard/wiseman';

import Yup from '../../../yup';

export const validationSchema = Yup.object().shape({
  client: Yup.object().shape({
    name   : Yup.string().required(),
    surname: Yup.string().required(),
    phone  : Yup.string().required(),
    email  : Yup.string()
      .email('Invalid email')
      .required(),
    language: Yup.string().required('No language selected'),
  }),
  flight: Yup.object().shape({
    number: Yup.string()
      .matches(/^[A-Z0-9]{3,}$/, 'Should be an IATA code')
      .required(),
    date: Yup.string().required(),
  }),
  service: Yup.object().shape({
    address: Yup.object()
      .shape({
        street  : Yup.string().required('Not valid address'),
        city    : Yup.string().required('Not valid address'),
        country : Yup.string().required('Not valid address'),
        location: Yup.object().shape({
          lat: Yup.string().required('Not valid address'),
          lng: Yup.string().required('Not valid address'),
        }),
        poi: Yup.string().required('Not valid address'),
      })
      .required(),
    type   : Yup.string().required(),
    numBags: Yup.number()
      .positive('Should select a minimun of 1 bag')
      .required(),
    pickup: Yup.object()
      .when('type', {
        is  : type => type !== SERVICE_TYPES.SKIP_BAGGAGE_CLAIM,
        then: Yup.object()
          .shape({
            time: Yup.object().shape({
              date    : Yup.string().required('Not valid pickup date'),
              from    : Yup.string().required('Not valid pickup time'),
              to      : Yup.string().required('Not valid pickup time'),
              timeSlot: Yup.number().required('Not valid pickup time'),
              timezone: Yup.string().required('Not valid pickup time'),
            }),
          })
          .required('Pickup is required'),
      }),
    delivery: Yup.object()
      .when('type', {
        is  : type => type !== SERVICE_TYPES.CHECKIN,
        then: Yup.object()
          .shape({
            time: Yup.object().shape({
              date    : Yup.string().required('Not valid delivery date'),
              from    : Yup.string().required('Not valid delivery time'),
              to      : Yup.string().required('Not valid delivery time'),
              timeSlot: Yup.number().required('Not valid delivery time'),
              timezone: Yup.string().required('Not valid delivery time'),
            }),
          })
          .required('Delivery is required'),
      }),
  }),
});

export const INITIAL_VALUES = {
  client: {
    name    : '',
    surname : '',
    phone   : '',
    email   : '',
    language: '',
  },
  flight: {
    number: '',
    date  : '',
  },
  flightSelected: null,
  service       : {
    type   : '',
    numBags: 1,
    address: {},
    pickup : {
      date: '',
      time: {},
    },
    delivery: {
      date: '',
      time: {},
    },
  },
};

// Lost and found
